<template>
  <transition name="el-fade-in-linear">
    <div class="schedule-post-detail-component" v-if="showModal">
      <div class="main-container">
        <detail-preview
          :story="story"
          :igTV="igTV"
          v-if="showPreviewModal"
          :images="postInfo.images"
          style="margin-right: 5px"
          :always-tags="always"
        ></detail-preview>
        <delete-preview
          v-if="showDelPreviewModal"
          :image="postInfo.proofUrl"
          style="margin-right: 5px"
        ></delete-preview>
        <hi-dialog
          class="detail-dialog"
          :title="title"
          :hideClose="postInfo.validate"
          @close="showModal = false"
        >
          <hi-button
            class="edit-btn"
            type="text"
            slot="left"
            v-show="edit"
            @click.native="editClick"
            >Edit</hi-button
          >
          <div class="scroll-view">
            <div class="user-container" v-if="postInfo.validate">
              <div class="user-item">
                <div
                  class="image"
                  v-lazy:background-image="postInfo.user.social_profile_picture"
                  :key="postInfo.user.social_profile_picture"
                >
                  <div
                    v-if="postInfo.user.social_network === 1"
                    class="ins-user-icon"
                  ></div>
                  <div
                    v-if="postInfo.user.social_network === 2"
                    class="fb-page-user-icon"
                  ></div>
                  <div
                    v-if="postInfo.user.social_network === 3"
                    class="fb-group-user-icon"
                  ></div>
                  <div
                    v-if="postInfo.user.social_network === 4"
                    class="tw-user-icon"
                  ></div>
                </div>
                <div class="username">{{ postInfo.user.social_username }}</div>
              </div>
            </div>
            <div class="top-container">
              <div v-if="!igTV" class="image-container">
                <div
                  v-if="postInfo.mediaList.length > 0"
                  @click="showImagesPreview"
                  v-lazy:background-image="postInfo.coverUrl"
                  :key="postInfo.coverUrl"
                  :class="{ story }"
                  class="post-image"
                >
                  <div class="video-icon" v-show="hasVideo"></div>
                  <div
                    v-show="postInfo.mediaList.length > 1"
                    class="mul-icon"
                  ></div>
                </div>
                <template v-if="!story">
                  <div
                    class="text"
                    v-show="postInfo.caption"
                    v-text="postInfo.caption"
                  ></div>
                  <!--沒有描述顯示灰字 no caption-->
                  <div
                    class="text no-text"
                    v-show="!postInfo.caption"
                    v-text="'No caption'"
                  ></div>
                </template>
              </div>
              <url
                class="url-container"
                :url="postInfo.storyUrl"
                :readonly="true"
                v-if="postInfo.storyUrl && !story"
              ></url>
            </div>
            <!-- 之所以没复用之前菜单，是因为story post igtv的菜单字段相同但是顺序变化太大，无法统一 -->
            <template v-if="igTV">
              <div class="image-container ig-tv">
                <div class="ig-tv-text-container">
                  <div class="title">{{ postInfo.title }}</div>
                  <div class="text" v-show="postInfo.caption">
                    {{ postInfo.caption }}
                  </div>
                  <!--沒有描述顯示灰字 no caption-->
                  <div class="text no-text" v-show="!postInfo.caption">
                    No caption
                  </div>
                </div>
                <div
                  v-if="postInfo.mediaList.length > 0"
                  @click="showImagesPreview"
                  v-lazy:background-image="postInfo.coverUrl"
                  :key="postInfo.coverUrl"
                  :class="{ story }"
                  class="post-image"
                >
                  <div class="video-icon" v-show="hasVideo"></div>
                  <div
                    v-show="postInfo.mediaList.length > 1"
                    class="mul-icon"
                  ></div>
                </div>
              </div>
              <div class="detail-item">
                <div class="title">Post a Preview</div>
                <div class="text">
                  {{ postInfo.igtvFeedPreview ? "On" : "Off" }}
                </div>
              </div>
              <div class="detail-item">
                <div class="title">Time Zone</div>
                <div class="text">{{ postInfo.tzName }}</div>
              </div>
              <div class="detail-item">
                <div class="title">Post Time</div>
                <div class="text">{{ postTimeStr }}</div>
              </div>
              <div class="detail-item" v-show="deleteTimeStr">
                <div class="title">Delete Time</div>
                <div class="text">{{ deleteTimeStr }}</div>
              </div>
              <div
                class="detail-item click"
                @click="openComment"
                v-show="postInfo.firstComment"
              >
                <div v-if="!twitter" class="title">Add First Comment</div>
                <div v-if="twitter" class="title">Add First Reply</div>
                <div class="text">{{ postInfo.firstComment }}</div>
              </div>
            </template>
            <template v-else>
              <!--刪除狀態顯示該樣式-->
              <div v-if="isDel" class="del-info">
                <image-shade v-if="postInfo.proofUrl" :src="postInfo.proofUrl">
                  <div
                    @click="showDelPreview"
                    :style="{ 'background-image': `url(${postInfo.proofUrl})` }"
                    class="image"
                  ></div>
                </image-shade>
                <div v-show="postInfo.proofUrl === ''" class="image fail">
                  Screenshot failed
                </div>
              </div>
              <div v-show="posted && !story" class="post-info">
                <div class="post-info-item">
                  <div class="icon like"></div>
                  <div class="num-text">{{ postInfo.likeNum }}</div>
                </div>
                <!--只有類型為視頻才顯示-->
                <div v-show="hasVideo" class="post-info-item">
                  <div class="icon view"></div>
                  <div class="num-text">{{ postInfo.viewNum }}</div>
                </div>
                <div
                  v-if="postInfo.user.social_network === 4"
                  class="post-info-item"
                >
                  <div class="icon forward"></div>
                  <div class="num-text">{{ postInfo.forwardNum }}</div>
                </div>
                <div v-else class="post-info-item">
                  <div class="icon common"></div>
                  <div class="num-text">{{ postInfo.commentNum }}</div>
                </div>
              </div>

              <div
                class="detail-item click"
                @click="showTagPreview"
                v-show="tagPeopleText"
              >
                <div class="title">Tag People</div>
                <div class="text">{{ tagPeopleText }}</div>
              </div>
              <div class="detail-item" v-show="postInfo.locationName && !story">
                <div class="title">Location</div>
                <div class="text">{{ postInfo.locationName }}</div>
              </div>
              <div
                class="detail-item click"
                @click="openComment"
                v-show="postInfo.firstComment && !story"
              >
                <div class="title">First Comment</div>
                <div class="text">{{ postInfo.firstComment }}</div>
              </div>
              <div
                class="detail-item click"
                @click="openTagProducts"
                v-show="tagProductsText"
              >
                <div class="title">Tag Products</div>
                <div class="text">{{ tagProductsText }}</div>
              </div>
              <div class="detail-item">
                <div class="title" v-show="!story">Post Time</div>
                <div class="title" v-show="story">Upload Time</div>
                <div class="text">{{ postTimeStr }}</div>
              </div>
              <div class="detail-item" v-show="deleteTimeStr">
                <div class="title">Delete Time</div>
                <div class="text">{{ deleteTimeStr }}</div>
              </div>
              <div class="detail-item">
                <div class="title">Time Zone</div>
                <div class="text">{{ postInfo.tzName }}</div>
              </div>
              <div
                v-show="postInfo.storyUrl && instagram"
                class="story-container"
              >
                <div class="title-text">Story URL</div>
                <div class="url-text">{{ postInfo.storyUrl }}</div>
              </div>
            </template>
            <template v-if="!postInfo.validate">
              <div class="detail-btn" v-show="hasPostNow" @click="postNow">
                Post Now
              </div>
              <div class="detail-btn" @click="againClick" v-show="!notAutoPost">
                Schedule Again
              </div>
              <div
                class="detail-btn"
                v-show="posted && !isDel && !storyIsTimeOut"
                @click="viewClick"
              >
                {{ viewOnText }}
              </div>
              <div class="detail-btn" @click="delClick">{{ deleteText }}</div>
              <div
                class="detail-btn"
                v-show="
                  posted &&
                  !isDel &&
                  !storyIsTimeOut &&
                  (postInfo.user.social_network === 2 ||
                    postInfo.user.social_network === 4)
                "
                @click="removeClick"
              >
                {{ removeText }}
              </div>
            </template>
          </div>
          <template v-if="postInfo.validate">
            <div class="bottom-container">
              <hi-button class="btn" @click.native="approveClick(2)"
                >Approve</hi-button
              >
              <hi-button type="text" class="btn" @click.native="approveClick(3)"
                >Decline</hi-button
              >
            </div>
          </template>
        </hi-dialog>
        <comment-preview
          v-if="showCommentModal"
          :comment="postInfo.firstComment"
          style="margin-left: 5px"
        ></comment-preview>
      </div>
    </div>
  </transition>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.schedule-post-detail-component {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  .user-container {
    padding: 5px 20px;
    border-bottom: 1px solid #e6e6e6;
    .user-item {
      display: flex;
      align-items: center;
      margin-right: 15px;

      .image {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-size: contain;
        background-position: center;
        position: relative;
      }

      .username {
        margin: 0 7px;
        font-size: 14px;
      }
    }
  }
  .detail-dialog {
    width: 480px;
    height: 700px;
    .scroll-view {
      overflow: auto;
      flex: 1;
      padding-bottom: 60px;
    }
    .bottom-container {
      border-top: 1px solid #e5e5e5;
      padding: 0 20px;
      height: 64px;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      .btn {
        margin-left: 10px;
        border: 2px solid #e62b55;
      }
    }
  }

  .main-container {
    display: flex;
    justify-content: flex-start;

    .edit-btn {
      padding: 0;
    }
    .top-container {
      border-bottom: 1px solid #e6e6e6;
      .url-container {
        margin-top: -30px;
      }
    }
    .image-container {
      padding: 15px 20px;
      display: flex;
      min-height: 150px;
      &.ig-tv {
        .post-image {
          margin-right: 0;
          margin-left: 15px;
        }
        .ig-tv-text-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          .title {
            font-size: 14px;
            padding-bottom: 10px;
            border-bottom: 1px solid #e6e6e6;
          }
          .text {
            padding-top: 15px;
            max-height: 150px;
          }
        }
      }
      .post-image {
        width: 123px;
        height: 123px;
        background-color: #e5e5e5;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        .mul-icon {
          background-image: url("../../../../../public/images/library/album@3x.png");
          width: 25px;
          height: 25px;
          background-size: contain;
          background-position: center;
          position: absolute;
          right: 10px;
          top: 10px;
        }

        &.story {
          height: 220px;
        }

        .video-icon {
          width: 80px;
          height: 80px;
          z-index: 2;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          background-image: url("../../../../../public/images/schedule_posts/list/video.png");
        }
      }
      .text {
        flex: 1;
        max-height: 198px;
        overflow-y: auto;
        font-size: 14px;
        white-space: pre-wrap;
        word-break: break-all;
        &.no-text {
          color: @font-color-gray;
        }
      }
    }

    .del-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .image-container {
        padding: 12px 20px 0 20px;
        min-height: auto;
      }
      .image {
        width: 440px;
        height: 120px;
        background-position: center;
        background-size: cover;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 24px;
        font-weight: lighter;
        border: 1px solid rgb(230, 230, 230);
        &.fail {
          background: #cccccc;
        }
      }
    }

    .post-info {
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-bottom: 1px solid #e5e5e5;
      height: 44px;
      font-size: 14px;

      .post-info-item {
        display: flex;
        align-items: center;

        .icon {
          background-size: contain;
          width: 20px;
          height: 20px;
          margin-right: 11px;

          &.like {
            background-image: url("../../../../../public/images/schedule_posts/list/icon_like@3x.png");
          }

          &.common {
            background-image: url("../../../../../public/images/schedule_posts/list/icon_com@3x.png");
          }
          &.forward {
            background-image: url("../../../../../public/images/schedule_posts/list/posted_icon_forward@3x.png");
          }
          &.view {
            background-image: url("../../../../../public/images/schedule_posts/list/icon_view@3x.png");
          }
        }

        .num-text {
          font-size: 16px;
        }
      }
    }

    .detail-item {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e6e6e6;
      padding: 0 20px;
      font-size: 14px;

      &.click {
        cursor: pointer;
      }

      .title {
        white-space: nowrap;
      }

      .text {
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 40px;
        white-space: nowrap;
        color: rgb(90, 90, 90);
      }
    }

    .story-container {
      height: 80px;
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      border-bottom: 1px solid #e6e6e6;
      font-size: 14px;
    }

    .detail-btn {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: @color-primary;
      border-bottom: 1px solid #e6e6e6;
      cursor: pointer;

      &:hover,
      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import hiButton from "../../../common/button/Index";
import detailPreview from "./DetailPreview";
import deletePreview from "./DeletePreview";
import commentPreview from "./CommentPreview";
import moment from "moment-timezone";
import {
  delPost,
  removePost,
  postNow,
  approvePostBy,
} from "../../../../service/post";
import { showErrorMsg } from "../../../../utils/errors";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../../store/mutation-types";
import { mapGetters } from "vuex";
import { imageLoad } from "../../../../utils/media";
import ImageShade from "../../../common/media/ImageShade";
import { Post } from "../../../../service/model/post";
import url from "../../../../components/common/form/Url";
export default {
  name: "SchedulePostDetailComponent",
  components: {
    ImageShade,
    hiDialog,
    detailPreview,
    deletePreview,
    commentPreview,
    hiButton,
    url,
  },
  data() {
    return {
      showModal: false,
      showPreviewModal: false, // 多图预览
      showDelPreviewModal: false, // 展示删除图片
      showCommentModal: false, // 是否展示comment弹出
      always: false, // 是否永远显示tag
      postInfo: null,
    };
  },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE, // 当前选中publisher
    }),
    igTV() {
      return this.postInfo.mediaType === 22;
    },
    // 是否only text模式
    onlyText() {
      return this.postInfo.mediaType === 90;
    },
    viewOnText() {
      if (this.instagram) {
        return "View on Instagram";
      } else if (this.facebook) {
        return "View on Facebook";
      } else if (this.twitter) {
        return "View on Twitter";
      }
    },
    /**
     * 如果是story则判断是否距离发送时间超过24小时，如果超过则不显示view on instagram 和 remove this story in instagram
     */
    storyIsTimeOut() {
      if (this.story) {
        return moment().diff(this.postInfo.postTime, "d") >= 1;
      }
      return false;
    },
    title() {
      if (this.igTV) {
        return "IGTV";
      }
      if (this.story) {
        return "Story";
      } else {
        return "Post";
      }
    },
    deleteText() {
      if (this.story) {
        return "Delete this Story";
      } else {
        return "Delete this Schedule";
      }
    },
    removeText() {
      if (this.instagram) {
        if (this.story) {
          return "Remove this Story on Instagram";
        } else {
          return "Remove this post on Instagram";
        }
      } else if (this.facebook) {
        return "Remove on Facebook";
      } else if (this.twitter) {
        return "Remove on Twitter";
      }
    },
    instagram() {
      return this.postInfo.user.social_network === 1;
    },
    facebook() {
      return (
        this.postInfo.user.social_network === 2 ||
        this.postInfo.user.social_network === 3
      );
    },
    facebookGroup() {
      return this.postInfo.user.social_network === 3;
    },
    twitter() {
      return this.postInfo.user.social_network === 4;
    },
    /**
     * 计算user tag
     */
    userTags() {
      let tags = [];
      this.postInfo.mediaList.forEach((img) => {
        img.usertags.forEach((tag) => {
          // 查看是否存在重复项
          const index = tags.findIndex((t) => t.user_id === tag.user_id);
          if (index === -1) {
            tags.push(tag);
          }
        });
      });
      return tags;
    },
    /**
     * 格式化tag people
     */
    tagPeopleText() {
      if (this.userTags.length > 1) {
        return `${this.userTags.length} People`;
      } else if (this.userTags.length === 1) {
        return this.userTags[0].username;
      } else {
        return "";
      }
    },
    /**
     * 计算tag products 文案
     */
    tagProductsText() {
      if (this.tagProducts.length > 0) {
        return `${this.tagProducts.length} Products`;
      } else {
        return "";
      }
    },
    /**
     * 计算product tag
     */
    tagProducts() {
      let tags = [];
      this.postInfo.mediaList.forEach((img) => {
        if (img.product_tags) {
          img.product_tags.forEach((tag) => {
            // 查看是否存在重复项
            const index = tags.findIndex((t) => t.id === tag.id);
            if (index === -1) {
              tags.push(tag);
            }
          });
        }
      });
      return tags;
    },
    /**
     * post中是否含有視頻
     */
    hasVideo() {
      // 視頻 或者 story中是视频
      return this.postInfo.images.findIndex((m) => m.type === 2) !== -1;
    },
    /**
     * 格式化post time
     */
    postTimeStr() {
      return moment
        .tz(this.postInfo.postTime, this.postInfo.tzName)
        .format("MMM DD, YYYY HH:mm");
    },
    /**
     * 格式化delete time
     */
    deleteTimeStr() {
      if (this.postInfo.deleteTime) {
        return moment
          .tz(this.postInfo.deleteTime, this.postInfo.tzName)
          .format("MMM DD, YYYY HH:mm");
      }
    },
    /**
     * 是否已发布状态
     */
    posted() {
      return (
        // 发送成功可以是因为实际发送成功状态 或者发送成功但是删除失败 或者手动但是未发布
        this.postInfo.state === "post-success" ||
        this.postInfo.status === 1 ||
        this.postInfo.state === "del-fail"
      );
    },
    /**
     * 图片删除失败
     */
    postDelFail() {
      return this.postInfo.status === "del-fail";
    },
    /**
     * 是否有post now 按钮
     */
    hasPostNow() {
      // 如果当前用户为"无密码" 则不显示post now 因为无密码无法进行发布
      if (this.currentPublisher.status === 2) {
        return false;
      }
      // 手动 和 自动发布 但是还未发布显示post now
      return this.edit;
    },
    /**
     * 是否可编辑(处于未发布状态)
     */
    edit() {
      return (
        this.postInfo.status === 0 &&
        !this.notAutoPost &&
        !this.postInfo.validate
      );
    },
    /**
     * 是否已删除
     */
    isDel() {
      return this.postInfo.status === 21;
    },
    /**
     * 判断是否为story
     */
    story() {
      return this.postInfo.mediaType === 3;
    },
    notAutoPost() {
      return this.postInfo.state === "post-not-auto";
    },
  },
  methods: {
    async approveClick(status) {
      if (this.postInfo.postTime.isBefore(moment())) {
        this.$router.replace({
          name: "ValidateDownloadPage",
          query: { msg: "This schedule is expired." },
        });
        return;
      }
      const loading = this.$loading();
      try {
        await approvePostBy({ status, token: this.$route.params.token });
        // 审批后跳转下载页面 2：接受，3：拒绝
        const type = status === 2 ? "approve" : "decline";
        this.$router.push({
          name: "ValidateDownloadPage",
          query: { type, username: this.postInfo.user.social_username },
        });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 打开product
     */
    async openTagProducts() {
      await this.showImagesPreview();
      this.always = true;
    },
    openComment() {
      this.showCommentModal = true;
    },
    /**
     * 编辑按钮点击事件
     */
    editClick() {
      // 关闭当前页面
      this.showModal = false;
      const scheduleForm = {
        images: this.postInfo.images,
        type: "edit",
        form: this.postInfo.form,
        mediaType: this.postInfo.mediaType,
      };
      this.$bus.$emit("showScheduleForm", scheduleForm);
    },
    /**
     * Schedule Again 点击事件
     */
    againClick() {
      // 关闭当前页面
      this.showModal = false;
      if (this.postInfo.images.length === 0) {
        this.$bus.$emit("showScheduleForm");
      }
      const scheduleForm = {
        images: this.postInfo.images,
        type: "again",
        form: this.postInfo.form,
        mediaType: this.postInfo.mediaType,
      };
      this.$bus.$emit("showScheduleForm", scheduleForm);
    },
    /**
     * 关闭所有弹出
     */
    closeAll() {
      this.showPreviewModal = this.showDelPreviewModal = false;
    },
    /**
     * 显示多图预览
     */
    async showImagesPreview() {
      try {
        this.closeAll();
        this.always = false;
        this.showPreviewModal = true;
      } catch (e) {
        showErrorMsg(e);
      }
    },
    /**
     * 显示tag 页面
     */
    async showTagPreview() {
      await this.showImagesPreview();
      this.always = true;
    },
    /**
     * 显示删除图片
     */
    showDelPreview() {
      this.closeAll();
      this.showDelPreviewModal = true;
    },
    /**
     * 显示信息
     */
    async show(model) {
      const loading = this.$loading();
      try {
        this.closeAll();
        this.showCommentModal = false;
        this.showModal = true;
        this.postInfo = model;
        if (!this.hasVideo) {
          const image = new Image();
          image.src = model.coverUrl;
          // 获取图片宽高比
          await imageLoad({ image });
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
        // 如果是审核则自动打开图片页面
        if (model.validate) {
          this.showImagesPreview();
        }
      }
    },
    /**
     * 马上发布
     */
    async postNow() {
      // 获取当前选中publisher
      const publisherId = this.currentPublisher.publisherId;
      const loading = this.$loading();
      try {
        await postNow({ id: this.postInfo.id, publisherId });
        // 刷新日历数据
        await this.$parent.initData(true);
        this.showModal = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * View on Instagram 点击事件
     */
    viewClick() {
      if (this.instagram) {
        window.open(this.postInfo.insUrl);
      } else if (this.facebook) {
        window.open(this.postInfo.facebookUrl);
      } else if (this.twitter) {
        window.open(this.postInfo.twitterUrl);
      }
    },
    /**
     * Delete this Schedule 点击事件
     */
    async delClick() {
      const loading = this.$loading();
      try {
        await delPost({ id: this.postInfo.id });
        // 刷新日历数据
        await this.$parent.initData(true);
        this.showModal = false;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * Remove this post on Instagram 点击事件
     */
    async removeClick() {
      const loading = this.$loading();
      try {
        const info = await removePost({ pk: this.postInfo.id });
        this.postInfo = new Post(info);
        if (this.instagram) {
          this.showDelPreview();
        }
        // 刷新日历数据
        await this.$parent.initData(true);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
};
</script>
